import { animate, state, style, transition, trigger } from '@angular/animations';
import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/merge';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { BaseComponent } from '../../../core/components';
import { LoanModel, LoanTypeModel } from '../../../models';
import { LoanService, SiteService, TenantService } from '../../../services';
import { SecurityHelper } from '../../../shared/helpers';
@Component({
    selector: 'app-mobile-loans-create',
    templateUrl: './loans-create.component.html',
    styleUrls: ['../../layout/layout.component.scss', '../../layout/mobile.css'],
    animations: [
        trigger('slideIn', [
            state('*', style({ 'overflow-y': 'hidden', 'overflow-x': 'hidden' })),
            state('void', style({ 'overflow-y': 'hidden', 'overflow-x': 'hidden' })),
            transition('* => void', [
                style({ height: '*' }),
                animate(300, style({ height: 0 }))
            ]),
            transition('void => *', [
                style({ height: '0' }),
                animate(300, style({ height: '*' }))
            ])
        ])
    ]
})
export class MobileLoansCreateComponent extends BaseComponent implements OnInit {
    @ViewChild('imagePreview') imagePreviewEl: ElementRef;
    @ViewChild('imageUpload') imageUploadEl: ElementRef;
    @ViewChild('additionalItemIds') additionalItemIdsContEl: ElementRef;
    //FORM
    public loanForm: any;
    disableContactsInfo: boolean = false;
    isAdminOrUserEditor: boolean;
    model: any;
    currentUser: any;
    tenantsList: any;
    customersList: any;
    sitesList: any;
    loanTypesList: any;
    loanedDate: NgbDateStruct;
    returnedDate: NgbDateStruct;
    defaultDaysReturn: number = 365; //1 YEAR FROM LOANING
    photoSrc: string | ArrayBuffer = "";
    fileName: string = "";
    public showSpinner: boolean = false;
    public finalCustomerList: any;
    public filteredCustomers: any;

    //LOAN PROPERTIES
    isCustomerSelected: boolean = false;
    selectedCustomerLoanCount: number = 0;
    selectedCustomerRemainingLoans: number = 5;
    currentNumOfLoans: number = 1;
    additionalInputCounter: number = 1;

    //STEPS
    isStep1: boolean = true;
    isStep2: boolean = false;
    isStep3: boolean = false;
    isStep4: boolean = false;
    isStep5: boolean = false;

    currentStep: any;

    //SEARCHING
    public searching = false;
    public searchFailed = false;
    public customerId: number = 0;
    public customerName: string = '';
    public hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);

    @ViewChild('customerSearch') customerSearchInput: ElementRef;
    photoRequired: boolean = false;
    showReturnDate: boolean = false;
    isSending: boolean = false;

    constructor(
        private loanService: LoanService,
        private tenantService: TenantService,
        private siteService: SiteService,
        private toastr: ToastsManager,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
        private formBuilder: FormBuilder,
        private elem: ElementRef
    ) {
        super(router)
    }

    public ngOnInit() {
        this.model = new LoanModel();
        this.setDefaults();
        //this.loadAllMergedCustomers();
        this.loadSites(this.accountId);
        this.loadLoanTypes();

        this.loanForm = this.formBuilder.group({
            'Company': ['', Validators.required]
        });

    }

    copyNameToRecieveBy() {
        // 
        if (this.model.ReceivedBy == undefined || this.model.ReceivedBy == '') {
            this.model.ReceivedBy = this.model.Customer.Name;
        }

    }

    public preselectMessageType(e) {

        //let value = e.value;
        //this.model.MessageTypeId = Number(e);
        if (this.model.Customer.MobileNumber == '' || this.model.Customer.MobileNumber == undefined) {
            this.model.MessageTypeId = 1;
        } else if (this.model.Customer.Email == '' || this.model.Customer.Email == undefined) {
            this.model.MessageTypeId = 2;
        } else if (this.model.Customer.Email != '' || this.model.Customer.Email != undefined && this.model.Customer.MobileNumber != '' || this.model.Customer.MobileNumber != undefined) {
            this.model.MessageTypeId = 3;
        }

    }

    public setDefaults() {
        let now = new Date();
        this.isAdminOrUserEditor = super.currentRole() === 'admin';
        this.accountId = super.currentLoggedUser().accountId;

        this.loanedDate = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
        let yearAfter = new Date(now.setDate(now.getDate() + this.defaultDaysReturn));
        this.returnedDate = { year: yearAfter.getFullYear(), month: yearAfter.getMonth() + 1, day: yearAfter.getDate() }

        this.model.GivenBy = super.currentLoggedUser().displayName;
        this.model.CreatedBy = super.currentLoggedUser().displayName;
        this.model.LastModifiedBy = super.currentLoggedUser().displayName;

        this.model.LoanId = SecurityHelper.createSixDigitLoanId();
        this.currentStep = 1;
        this.model.SiteId = +localStorage.getItem('currentSiteId');
        this.loadAllMergedCustomers();
    }

    public loadSites(id?: number) {
        this.siteService.getSitesByAccountList(id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                this.sitesList = response.Data;
            });
    }

    getSite() {
        if (this.sitesList != undefined && this.sitesList.length > 0) {

            return this.sitesList.filter(x => x.Id == this.model.SiteId)[0].Name;
        }

    }

    public loadLoanTypes() {
        this.loanService.getLoanTypesByAccount(this.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                this.loanTypesList = response.Data;

                if (this.loanTypesList) {
                    this.model.TypeId = this.loanTypesList[0]?.Id
                    this.selectLoanType(this.model.TypeId)
                }
            });
    }

    public loadAllMergedCustomers() {
        this.loanService.getAllMergedCustomerList(this.accountId, this.model.SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                this.finalCustomerList = response.Data;
            });
    }

    public loadTenant(id) {
        this.tenantService.getTenant(id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {

                let tenantData = response.Data;
                this.model.CustomerTypeId = 2;
                let city = tenantData.City;//;tenantData.InvoiceZipAndCity && tenantData.InvoiceZipAndCity.indexOf(',') > -1 ? tenantData.InvoiceZipAndCity.split(",")[1] : '';
                let zipCode = tenantData.InvoiceZipAndCity && tenantData.InvoiceZipAndCity.indexOf(',') > -1 ? tenantData.InvoiceZipAndCity.split(",")[0] : '';

                this.model.Customer = {
                    //Name : tenantData.Name,
                    Company: tenantData.Name,
                    Email: tenantData.Email,
                    MobilePhone: tenantData.Phone,
                    Address1: tenantData.VisitingAddress,
                    City: city,
                    ZipCode: zipCode
                };

            });

    }

    public loadCustomer(id) {
        this.loanService.getCustomer(id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                this.model.Customer = response.Data;
                this.model.GivenBy = response.Data.Name;

                this.model.CustomerTypeId = 1;
            });
    }

    public loadData(id, type) {
        if (type === 'Customer') {
            this.loadCustomer(id)
        }
        else {
            this.loadTenant(id);
        }
    }

    public selectLoanType(e) {
        let value = Number(e);
        let loanType: LoanTypeModel = this.loanTypesList.filter((item) => {
            return item.Id === value;
        })[0];
        if (loanType) {
            this.photoRequired = loanType.IsPhotoRequired;
            this.showReturnDate = loanType.ShowReturnDate
        }
    }

    public validate() {
        let valid = true;
        //add more validation here
        if (this.photoRequired) {
            valid = this.model.PhotoString !== '';
        }
        return valid;
    }
    public validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    public isValidPhone(p) {
        var phoneRe = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
        var digits = p;
        return phoneRe.test(digits);
    }

    public saveChanges() {

        this.isSending = true;

        var t = this.model.Customer.accountId = this.accountId;
        if (this.model.Customer.Email != "" && this.model.Customer.Email != undefined) {
            if (!this.validateEmail(this.model.Customer.Email)) {
                this.toastr.error("Invalid Email Address", "Error");

                this.isSending = false;
                return;
            }
        } else {
            if (this.model.MessageTypeId == 1) {
                this.model.MessageTypeId = 4;
            }
        }

        if (this.model.Customer.MobileNumber != "" && this.model.Customer.MobileNumber != undefined) {
            if (!this.isValidPhone(this.model.Customer.MobileNumber)) {
                this.toastr.error("Invalid Mobile Number", "Error");

                this.isSending = false;
                return;
            }
        } else {
            if (this.model.MessageTypeId == 2) {
                this.model.MessageTypeId = 4;
            }
        }

        if (this.model.Customer.MobileNumber != "" && this.model.Customer.MobileNumber != undefined) {
            if (this.model.Customer.MobileNumber.charAt(0) != '+') {
                this.toastr.error("Invalid Mobile Number", "Error");

                this.isSending = false;
                return;
            }
        }

        this.showSpinner = true;
        this.model.LoanedDate = new Date(
            this.loanedDate.year,
            this.loanedDate.month,
            this.loanedDate.day);

        this.model.ReturnedDate = new Date(
            this.returnedDate.year,
            this.returnedDate.month,
            this.returnedDate.day);

        this.model.LoanedDateModel = this.loanedDate;
        this.model.ReturnedDateModel = this.returnedDate;

        this.loanService.saveLoan(this.model)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response) => {
                if (response.ErrorCode) {
                    this.isSending = false;
                    this.toastr.error(response.Message, "Error");
                }
                else {
                    this.isSending = false;
                    let id = response.Data.Id;
                    //this.toastr.success(response.Message, "Success"); 
                    this.router.navigate([`mobile/loans/${id}/preview`]);
                }

            });
    }

    public fileChange(fileInput: any) {
        let self = this;
        let file = <File>fileInput.target.files[0];
        if (file.size > 3000000) {
            this.toastr.error(`Photo upload limits 3MB of file, this file is ${(file.size / 1024 / 1024).toFixed(2)} MB. Please choose another one.`, "Error");
            return false;
        }
        this.fileName = file.name;
        var reader = new FileReader();
        reader.onload = function() {
            self.photoSrc = reader.result;
            self.model.PhotoString = (<string>reader.result).replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
        };
        reader.onerror = function(error) {
            console.log('Error: ', error);
        };

        reader.readAsDataURL(file);
    }

    public navigateToLanding() {
        this.router.navigate([`mobile`]);
    }

    public navigateToStep(step: number) {
        if (step === 2) {
            this.isStep1 = false;
            this.isStep2 = true;
            this.isStep3 = false;
            this.isStep4 = false;
            this.currentStep = 2;

            this.model.ItemNameId = !this.model.ItemNameId ? '' : this.model.ItemNameId;
            this.model.GivenBy = !this.model.GivenBy ? '' : this.model.GivenBy;
            this.model.ReceivedBy = !this.model.ReceivedBy ? '' : this.model.ReceivedBy;
            this.model.Description = !this.model.Description ? '' : this.model.Description;
        }
        else if (step === 3) {
            this.getAllNewItemNameIdValues();
            this.isStep1 = false;
            this.isStep2 = false;
            this.isStep3 = true;
            this.isStep4 = false;
            this.currentStep = 3;
            if (!this.photoSrc) {
                setTimeout(() => {
                    let imageUploadElement: HTMLElement = document.getElementById('mobile-upload') as HTMLElement;
                    imageUploadElement.click();
                }, 500);
            }

        }
        else if (step === 4) {
            this.isStep1 = false;
            this.isStep2 = false;
            this.isStep3 = false;
            this.isStep4 = true;
            this.currentStep = 4;
        }
        else {
            this.isStep1 = true;
            this.isStep2 = false;
            this.isStep3 = false;
            this.isStep4 = false;
            this.currentStep = 1;
        }
    }

    public getAllNewItemNameIdValues() {
        let elements = this.elem.nativeElement.querySelectorAll('.additionalItemNameId');
        let values = [];
        elements.forEach(function(element, i) {
            values.push(element.value);
        });
        if (values.length > 0) {
            this.model.ItemNameId = this.model.ItemNameId + ',' + values.join(',');
        }
    }

    public addNewItemIdInput() {
        if (this.selectedCustomerRemainingLoans >= this.currentNumOfLoans) {
            this.additionalInputCounter++;
            let template = '<div class="form-group mb-2 additional-item-id"><input type="text" placeholder="Item Name / ID (' + (this.additionalInputCounter) + ')" class="form-control input-sm additionalItemNameId"></div>'
            this.additionalItemIdsContEl.nativeElement.insertAdjacentHTML('beforeend', template);
            this.selectedCustomerRemainingLoans--;
        }
        else {
            this.toastr.error('You reached the loan limit per customer.', 'Error')
            return false;
        }

    }

    public selectCustomer(customerId, typeId) {
        this.isCustomerSelected = true;

        if (typeId == 2) {
            this.disableContactsInfo = true;
        } else {
            this.disableContactsInfo = false;
        }

        if (!customerId) {
            return false;
        }
        this.showSpinner = true;
        let selectedCustomer = this.finalCustomerList.filter((item) => {
            return item.Id === customerId && item.TypeId === typeId;
        })[0];

        this.selectedCustomerLoanCount = selectedCustomer.LoanCount;
        this.selectedCustomerRemainingLoans = selectedCustomer.RemainingLoanCount - 1;

        this.customerSearchInput.nativeElement.value = customerId;
        this.model.CustomerId = selectedCustomer.Id;
        this.loadData(selectedCustomer.Id, selectedCustomer.Type);

    }

    public selectMessageType(e) {
        let value = e.value;
        this.model.MessageTypeId = Number(value);
    }

    public clearNewItemIdInput() {
        this.elem.nativeElement.querySelectorAll('.additional-item-id').forEach(function(element, i) {
            element.remove();
        });
    }

    search = (text$: Observable<string>) =>
        text$
            .debounceTime(200)
            .distinctUntilChanged()
            .do(() => this.searching = true)
            .switchMap(term => {
                if (term.trim() === '') {
                    return Observable.of([]);
                }
                return this.loanService.getAllMergedCustomerFilterList(this.accountId, this.model.SiteId, term)
                    .map(results => results.sort((a, b) => {
                        let name1 = a.Name.toLowerCase(),
                            name2 = b.Name.toLowerCase();
                        if (name1 < name2) return -1
                        return name1 > name2 ? 1 : 0
                    }));
            })
            .do(() => this.searching = false)
            .merge(this.hideSearchingWhenUnsubscribed);
    formatter = (x: { Name: string }) => x.Name;
}



// WEBPACK FOOTER //
// ./src/app/components/mobile/loans/loans-create.component.ts